import { MutationTuple, useMutation } from '@apollo/client';

import {
  evictCache,
  RegenerateRdProjectDetailsMutation,
  RegenerateRdProjectDetailsMutationVariables,
  REGENERATE_RD_PROJECT_DETAILS,
} from '@neo.tax/shared';

export const useRegenerateRdProjectDetailsMutation = (): MutationTuple<
  RegenerateRdProjectDetailsMutation,
  RegenerateRdProjectDetailsMutationVariables
> =>
  useMutation<RegenerateRdProjectDetailsMutation, RegenerateRdProjectDetailsMutationVariables>(
    REGENERATE_RD_PROJECT_DETAILS,
    {
      // Refetching background operations locks the page straight away instead of on the next poll, and
      // refetching projects shows every row in the run as in progress.
      update: (cache) => {
        evictCache(cache, ['getBackgroundOperations', 'getRdProjects']);
      },
    },
  );
